import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames/bind'

import { QuestionIcon, ErrorIcon, SuccessIcon } from 'components/icon'
import { BalloonTooltip } from 'components/tooltip'

import styles from './caja_decorator.scss'

const Caja = InnerComponent => {
	class NewCaja extends PureComponent {

		constructor(props) {
			super(props)
			this.state = {
				showMessage: false,
			}
		}

		/* Todo: validate if this is still needed
		shouldComponentUpdate(nextProps) {
			if (this.props.button.active === true) {
				return this.props.active === nextProps.active
			} else {
				return true
			}
		}*/

		render() {
			let Icon = () => null
			if (this.props.status === 'success') {
				Icon = () => <SuccessIcon fillColor={this.props.icons.filled?'green':''} withInput={true} />
			} else if (this.props.status === 'error') {
				Icon = () => <ErrorIcon fillColor={this.props.icons.filled?'red':''} withInput={true} />
			} else if (this.props.tooltip) {
				Icon = () => (
					<BalloonTooltip
						tooltip={this.props.tooltip}
						isOpen={this.state.showMessage}
						onMouseEnterHandler={() => {
							this.setState({
								showMessage: true,
							})
						}}
						onMouseLeaveHandler={() => {
							this.setState({
								showMessage: false,
							})
						}}
					>
						<QuestionIcon fillColor={this.props.icons.fillColor} withInput={true}/>
					</BalloonTooltip>
				)
			}

			const noPadding = this.props.icons.active || this.props.boxType === 'withButton' || this.props.boxType === 'withIconButton' || this.props.boxType === 'withIconButtonFilled'


			return (
				<div styleName={
					classNames({
						block: true,
						blue: this.props.color === 'blue',
						yellow: this.props.color === 'yellow',
						cerulean: this.props.color === 'cerulean',
						'block--tooltip': this.props.tooltip,
						'block--success': this.props.status === 'success',
						'block--error': this.props.status === 'error',
						'block--active': this.props.active&&this.props.activeStyle,
						'block--disabled': this.props.disabled,
					})
				}>
					<div styleName={
						classNames({
							container: true,
							'w-icon': this.props.icons.active&&(this.props.tooltip||this.props.status!==''),
							'w-button': this.props.boxType === 'withButton',
							'w-icon-button': this.props.boxType === 'withIconButton',
							'w-icon-button-filled': this.props.boxType === 'withIconButtonFilled',
						})
					}>

						<div styleName='button__area'>
							<button {...this.props.button.props} styleName='button__area_button'>
								{this.props.button.data}
							</button>
						</div>
						<div styleName='input__area'>
							<InnerComponent {...this.props} noPadding={noPadding}/>
						</div>
						<div styleName='icon__area'>
							{this.props.icons.active && <Icon fillColor={this.props.icons.fillColor}/>}
						</div>
					</div>

					<div styleName={
						classNames({
							messages: true,
							'tooltip--show': this.props.status!=='error' && this.props.status !== 'success' && this.state.showMessage,
							'error--show': this.props.status === 'error',
							'info--show': this.props.status === 'info',
						})
					}>
						<p styleName='error'>{this.props.message}</p>
						<p styleName='tooltip'>{this.props.tooltip}</p>
					</div>
				</div>
			)
		}
	}

	NewCaja.defaultProps = {
		boxType: 'standard', // standard, withButton, withIconButton, withIconButtonFilled
		icons: {active: false, filled: false},
		button: {props: null, data: null},
		activeStyle: true,
		disabled: false,
	}

	NewCaja.propTypes = {
		boxType: PropTypes.string,
		tooltip: PropTypes.string,
		status: PropTypes.string,
		message: PropTypes.string,
		color: PropTypes.string,
		icons: PropTypes.object,
		active: PropTypes.bool,
		button: PropTypes.object,
		activeStyle: PropTypes.bool,

	}

	return CSSModules(NewCaja, styles, {allowMultiple: true})
}

export default Caja
